import styled from 'styled-components';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import Responsive from './media-queries';

const Wrapper = styled.div`
  background: ${(props) =>
    props.colour === 'primary'
      ? props.theme.colours.primary
      : props.colour === 'secondary'
        ? props.theme.colours.secondary
        : props.backgroundColour
          ? props.backgroundColour
          : props.theme.colours.white};
  border-radius: 10px;
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
  color: ${(props) =>
    props.colour === 'primary'
      ? props.theme.colours.white
      : props.colour === 'secondary'
        ? props.theme.colours.white
        : props.fontColour
          ? props.fontColour
          : props.theme.colours.darkGrey};
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  width: 100%;
  margin-bottom: ${(props) =>
    props.addBottomMargin === 'small'
      ? '2rem'
      : props.addBottomMargin === 'large'
        ? '3rem'
        : '0px'};
  transform: translateZ(0);

  ${Responsive.lg} {
    flex-direction: row;
  }
`;

const Content = styled.div`
  height: 100%;
  order: 1;
  padding: ${(props) => props.theme.layout.gutter.sm};
  width: 100%;
  z-index: 1;
  flex-basis: ${(props) => (props.hasImage ? '50%' : '100%')};
  text-align: ${(props) => (props.imageFirst ? 'right' : 'left')};

  ${Responsive.md} {
    padding: ${(props) => props.theme.layout.gutter.md};
  }

  ${Responsive.lg} {
    order: ${(props) => (props.imageFirst ? '1' : '0')};
    padding: ${(props) => props.theme.layout.gutter.lg};
  }
`;

const ImageContainer = styled.div`
  position: relative;
  flex-basis: ${(props) => (props.imageHeight ? props.imageHeight : '300px')};

  ${Responsive.lg} {
    flex-basis: 50%;
  }
`;

const ImageWrapper = styled.div`
  display: flex;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
`;

const ImageStyled = styled(GatsbyImage)`
  display: ${(props) => (props.$hideImageForMobile ? 'none' : 'block')};
  z-index: 1;
  width: 100%;

  ${Responsive.lg} {
    display: block;
  }
`;

const BackgroundImageStyled = styled(GatsbyImage)`
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  left: 0;
  opacity: 0.15;
  position: absolute;
  top: 0;
  width: 100%;
`;

export const Card = (props) => {
  return (
    <Wrapper
      backgroundColour={props.backgroundColour}
      className={props.className}
      colour={props.colour}
      fontColour={props.fontColour}
      addBottomMargin={props.addBottomMargin}
    >
      <Content imageFirst={props.imageFirst} hasImage={props.image && true}>
        {props.children}
      </Content>
      {props.image && (
        <ImageContainer imageHeight={props.imageHeight}>
          <ImageWrapper>
            <ImageStyled
              alt=''
              $hideImageForMobile={props.hideImageForMobile}
              image={getImage(props.image)}
            />
          </ImageWrapper>
        </ImageContainer>
      )}
      {props.backgroundImage && (
        <BackgroundImageStyled alt='' image={getImage(props.backgroundImage)} />
      )}
    </Wrapper>
  );
};
